import { render, staticRenderFns } from "./add-new-rule.vue?vue&type=template&id=21f001ac&scoped=true&"
import script from "./add-new-rule.vue?vue&type=script&lang=js&"
export * from "./add-new-rule.vue?vue&type=script&lang=js&"
import style0 from "./add-new-rule.vue?vue&type=style&index=0&id=21f001ac&scoped=true&lang=css&"
import style1 from "./add-new-rule.vue?vue&type=style&index=1&lang=css&"
import style2 from "./add-new-rule.vue?vue&type=style&index=2&id=21f001ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f001ac",
  null
  
)

export default component.exports